import {Injectable} from '@angular/core';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {Observable} from 'rxjs';
import {MultipleFileUploadDialogParams} from './multiple-file-upload-dialog-params';
import {MultipleFileUploadDialogComponent} from './multiple-file-upload-dialog.component';

@Injectable({
    providedIn: 'root'
})
export class MultipleFileUploadDialogService {

    constructor(public dialog: MatDialog) {
    }

    openDialog(params: MultipleFileUploadDialogParams): Observable<boolean> {
        if (params) {
            const matDialogConfig = new MatDialogConfig();
            matDialogConfig.maxWidth = '768px';
            matDialogConfig.maxHeight = '812px';
            matDialogConfig.data = params;
            const dialogRef = this.dialog.open(MultipleFileUploadDialogComponent, matDialogConfig);
            return dialogRef.afterClosed();
        } else {
            console.error('No params provided for MultipleFileUploadDialog');
        }
    }
}
